export default {
  GET_ROLE: state => state.role,
  GET_ROLE_LIST: state => state.roleList,
}
